import FetchClient from 'ha/helpers/FetchClient';
import createMakeCall from 'ha/services/apiV2/createMakeCall';
import getBillingInformation from './getBillingInformation';
import updateBillingInformation from './updateBillingInformation';

const createMoneta = (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    getBillingInformation: getBillingInformation(makeCall),
    updateBillingInformation: updateBillingInformation(makeCall),
  };
};

export default createMoneta;
